module.exports = __webpack_public_path__ + "static/media/updates.dfcd378f.svg";